let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("91C8u")).then(() => parcelRequire('1Ce5i'));